// material
import { Card, Stack, Container, Typography, Box } from '@mui/material';
// components
import NewDataProductForm from '../../sections/service/NewDataProductForm';
import Page from '../../components/Page';

export default function CreateDataProduct() {
  return (
    <Page title="Add">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Create new data plan
          </Typography>
        </Stack>

        <Card sx={{ maxWidth: 500 }}>
          <Box p="20px">
            <NewDataProductForm />
          </Box>
        </Card>
      </Container>
    </Page>
  );
}
